import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { PaymentDisplayHelpersModule } from '@features/payment-display-helpers/payment-display-helpers.module';
import { SelectEmailTemplateModule } from '@features/system-emails/select-email-template/select-email-template.module';
import { SystemTagsModule } from '@features/system-tags/system-tags.module';
import { AccordionsModule } from '@yourcause/common/accordion';
import { AwardAmountControlComponent } from './award-amount-control/award-amount-control.component';
import { AwardsComponent } from './awards/awards.component';
import { BudgetFsTypeaheadComponent } from './budget-fs-typeahead/budget-fs-typeahead.component';
import { CreatePaymentPopoverButtonComponent } from './create-payment-popover-button/create-payment-popover-button.component';
import { InKindItemsSelectorTableComponent } from './in-kind-items-selector-table/in-kind-items-selector-table.component';
import { IsPaymentAmountDisabledPipe } from './pipes/is-payment-amount-disabled.pipe';
import { SimpleAwardModalComponent } from './simple-award-modal/simple-award-modal.component';


@NgModule({
  imports: [
    GCCoreModule,
    SystemTagsModule,
    ScrollingModule,
    PaymentDisplayHelpersModule,
    SelectEmailTemplateModule,
    AccordionsModule
  ],
  declarations: [
    AwardAmountControlComponent,
    InKindItemsSelectorTableComponent,
    SimpleAwardModalComponent,
    AwardsComponent,
    BudgetFsTypeaheadComponent,
    CreatePaymentPopoverButtonComponent,
    IsPaymentAmountDisabledPipe
  ],
  exports: [
    AwardsComponent,
    AwardAmountControlComponent,
    BudgetFsTypeaheadComponent,
    InKindItemsSelectorTableComponent,
    CreatePaymentPopoverButtonComponent
  ]
})
export class AwardsModule { }
